
    <button title="minimize / maximize player"
      [class.full-screen]="!fullScreen"
      (click)="togglePlayer()"
      class="btn btn-sm navbar-btn show-player pull-right">
      <icon name="chevron-down" class="icon-minimize"></icon>
      <icon name="expand" class="icon-max"></icon>
    </button>
  